import { X, Loader2, LinkIcon } from "lucide-react";
import { Badge } from "@/modern/components/ui/badge";
import { useEntityFileContext } from "@/react/components/entityViews/files/context/EntityFileContext";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/modern/components/ui/tooltip";

export const CompanyCamButton = () => {
  const { currentCCProject, entityRecord } = useEntityFileContext();

  const companyCamProjectId = entityRecord.companyCamProject;

  // Hide button if no project is linked
  if (!companyCamProjectId) return null;

  return (
    <div className="text-xs flex gap-2 text-muted-foreground items-center">
      <span>CC</span>
      <LinkIcon className="size-3" />
      <span>
        <Tooltip>
          <TooltipTrigger className="max-w-[15ch] flex items-center">
            <p className="truncate">{currentCCProject?.name || `Project ${companyCamProjectId}`}</p>
          </TooltipTrigger>
          <TooltipContent>
            <div>Company Cam project: {currentCCProject?.name || `Project ${companyCamProjectId}`}</div>
          </TooltipContent>
        </Tooltip>
      </span>
    </div>
  );
};

// left this here in case we need to revert to the old button
export const CompanyCamButtonOld = () => {
  const { currentCCProject, isFetchingCurrentProject, unsetCompanyCamProject, entityRecord } = useEntityFileContext();

  const companyCamProjectId = entityRecord.companyCamProject;

  // Hide button if no project is linked
  if (!companyCamProjectId) return null;

  const handleRemove = () => {
    unsetCompanyCamProject();
  };

  return (
    <div className="flex items-center gap-2 min-w-0 flex-shrink-0 text-xs">
      <label className="text-sm text-muted-foreground whitespace-nowrap flex-shrink-0">Company Cam</label>
      <Badge variant="muted" className="flex items-center gap-1 text-xs text-foreground">
        {isFetchingCurrentProject ? <Loader2 className="w-4 h-4 animate-spin" /> : <span>{currentCCProject?.name || `Project ${companyCamProjectId}`}</span>}
        <button onClick={handleRemove} className="ml-1 hover:bg-destructive/10 hover:text-destructive rounded-full p-0.5 transition-colors" title="Remove Company Cam project">
          <X className="w-3 h-3" />
        </button>
      </Badge>
    </div>
  );
};
